import React, { useEffect, useState, useRef } from 'react';
import { DateRangePicker, DateRange } from 'react-date-range';
import { Input } from 'antd';
import Moment from 'moment';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';


require('./dateRangePicker.css');

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

const CustomDateRangePicker = ({ onDateChange, months, maxDate, direction = 'vertical', className = '' }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const ref = useRef(null);
  const [selectionRange, setSelectedRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);

  const isMobile = useIsMobile();

  const isValidDate = (date) => date instanceof Date && !isNaN(date.getTime());

  const handleDateChange = (item) => {
    const { startDate, endDate } = item.selection;

    if (isValidDate(startDate) && isValidDate(endDate) && startDate.getTime() !== endDate.getTime()) {
      onDateChange(startDate, endDate);
      setSelectedRange([item.selection]);
      setShowDatePicker(false); // Ocultar el DatePicker después de seleccionar el rango
    } else {
      setSelectedRange([item.selection]);
    }
  };

  const toggleDatePicker = () => {
    setShowDatePicker(true); // Mostrar el DatePicker al hacer clic en los inputs
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDatePicker(false); // Ocultar el DatePicker al hacer clic fuera
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={ref} className={`${className}`}>
      <div className="d-flex justify-content-center">
        <Input
          type="text"
          value={
            selectionRange[0].startDate
              ? Moment(selectionRange[0].startDate).format('YYYY-MM-DD')
              : ''
          }
          readOnly
          onClick={toggleDatePicker}
          placeholder="Start Date"
          className="w-25 mr-2"
        />
        <span className="date-separator"> - </span>
        <Input
          type="text"
          value={
            selectionRange[0].endDate
              ? Moment(selectionRange[0].endDate).format('YYYY-MM-DD')
              : ''
          }
          readOnly
          onClick={toggleDatePicker}
          placeholder="End Date"
          className="w-25 ml-2"
        />
      </div>

      {showDatePicker && (
        <>
          {isMobile ? (
            <DateRange
              onChange={handleDateChange}
              showSelectionPreview={true}
              months={1}
              maxDate={maxDate}
              ranges={selectionRange}
              direction="vertical"
              className='themed-block'
            />
          ) : (
            <DateRangePicker
              onChange={handleDateChange}
              showSelectionPreview={true}
              months={months}
              maxDate={maxDate}
              ranges={selectionRange}
              direction='horizontal'
              preventSnapRefocus={true}
              calendarFocus="forwards"
              className='themed-block'
            />
          )}
        </>
      )}
    </div>
  );
};

export default CustomDateRangePicker;
